import { Client } from '@/manager/client/client.model';
import { Purchase } from '@/clickbuy/purchase/models/purchase.model';
import { BudgetLine } from '@/manager/budget/models/budget-line.model';
import { BudgetFee } from '@/manager/budget/models/budget-fee.model';
import { BankAccount } from '@/shared/models/bankAccount.model';
import { CreditCard } from '@/shared/models/creditCard.model';
import { Bill } from '@/clickbuy/purchase/models/bill.model';
import { BudgetSepaInfo } from '@/client/budget/models/budget-sepa-info.model';


export enum LastRequest {
    Convocation = 1,
    NumberFees = 2,
}

export enum BudgetPaymentStatus {
    Pending = 0,
    InProgress = 1,
    Completed = 2,
    Suspended = 3,
    WithoutConvocation = 4,
    Cancelled = 5,
}

export enum BudgetCommunicationStatus {
    Pending = 0,
    Dispatched = 1,
    Accepted = 2,
    Adjust = 3,
    Rejected = 4,
}

export enum BudgetStatus {
    Managed = 1,
    InProgress = 2,
}

export enum BudgetPaymentMethod {
    Card = 1,
    DirectDebit = 2,
    SendWireTransfer = 3,
}

export enum BudgetAlert {
    Unpaid = 1,
    NearPaid = 2,
    Itinery = 3,
    OverlappingProducts = 4,
}

export const BudgetPaymentStatusLiteral = [
    'Pendiente',
    'En marcha',
    'Completado',
    'Suspendido',
    'Sin convocatoria',
    'Cancelado',
]
;
export const BudgetCommunicationStatusListeral = [
    'Pendiente',
    'Aceptación pendiente',
    'Aceptado',
    'Validación pendiente',
    'Rechazado',
];

export const BudgetPaymentMethodLiteral = [
    'No seleccionado',
    'Tarjeta',
    'Domiciliado',
    'Transferencia',
];

export const BudgetAlertLiteral = [
    '',
    'Impago',
    'Fecha de pago próxima',
    'Conflicto en itinerario',
    'Productos solapados',
];


export interface BudgetInterface {
    id?: string;
    bill?: Bill;
    client?: Client;
    publicId?: number;
    purchase?: Purchase;
    document?: string;
    mandateDocument?: string;
    paymentStatus?: BudgetPaymentStatus;
    paymentMethod?: BudgetPaymentMethod;
    communicationStatus?: BudgetCommunicationStatus;
    totalFee?: number;
    pendingFee?: number;
    discountReservation?: number;
    discount?: number;
    discountSoonPayment?: number;
    totalPrepaidPrice?: number;
    totalPrice?: number;
    totalPriceTax?: number;
    totalPriceWithoutTax?: number;
    totalPaidPrice?: number;
    totalPendingPrice?: number;
    totalAmount?: number;
    totalFeePaid?: number;
    totalFeeRemaining?: number;
    convocationOrigin?: string;
    budgetLine?: BudgetLine[];
    budgetFee?: BudgetFee[];
    numberOfNotes?: number;
    delegation?: string;
    maxUnitFee?: number;
    numberOfFees?: number;
    hasIssue?: boolean;
    created?: string;
    bankAccount?: BankAccount;
    creditCard?: CreditCard;
    lastRequest?: LastRequest;
    alert?: BudgetAlert;
    dateExpiration?: string;
    billFiscalData?: boolean;
    acceptConditions?: boolean;
    budgetSepaInfo?: BudgetSepaInfo;
    moneyFlowDiscount?: number;
}

export class Budget implements BudgetInterface {
    public id?: string;
    public bill?: Bill;
    public client?: Client;
    public publicId?: number;
    public purchase?: Purchase;
    public document?: string;
    public mandateDocument?: string;
    public paymentStatus?: BudgetPaymentStatus;
    public paymentMethod?: BudgetPaymentMethod;
    public communicationStatus?: BudgetCommunicationStatus;
    public totalFee?: number;
    public pendingFee?: number;
    public discount?: number;
    public discountReservation?: number;
    public discountSoonPayment?: number;
    public totalPrepaidPrice?: number;
    public totalPaymentPending?: number;
    public totalPrice?: number;
    public totalPriceTax?: number;
    public totalPriceWithoutTax?: number;
    public totalPaidPrice?: number;
    public totalPendingPrice?: number;
    public totalAmount?: number;
    public totalFeePaid?: number;
    public totalFeeRemaining?: number;
    public convocationOrigin?: string;
    public budgetLine?: BudgetLine[];
    public budgetFee?: BudgetFee[];
    public numberOfNotes?: number;
    public delegation?: string;
    public maxUnitFee?: number;
    public numberOfFees?: number;
    public hasIssue?: boolean;
    public created?: string;
    public lastRequest?: LastRequest;
    public alert?: BudgetAlert;
    public dateExpiration?: string;
    public billFiscalData?: boolean;
    public acceptConditions?: boolean;
    public budgetSepaInfo?: BudgetSepaInfo;
    public moneyFlowDiscount?: number;

    constructor() {
        this.client = new Client();
        const newLine = new BudgetLine();
        this.budgetLine = [newLine];
        this.budgetFee = [];
        this.numberOfFees = 1;
        this.billFiscalData = false;
        this.budgetSepaInfo = new BudgetSepaInfo();
        this.discountSoonPayment = 0;
        this.discountReservation = 0;
        this.discount = 0;
    }
}
